import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
import { get } from "../../../popleads/networking/RequestService";

export const actionTypes = {
    Login: "[Login] Action",
    Logout: "[Logout] Action",
    Register: "[Register] Action",
    UserRequested: "[Request User] Action",
    UserLoaded: "[Load User] Auth API",
    SetUser: "[Set User] Action",
};

const initialAuthState = {
    user: { name: "" },
    authToken: undefined,
};

export const reducer = persistReducer(
    { storage, key: "v713-demo1-auth", whitelist: ["user", "authToken"] },
    (state = initialAuthState, action) => {
        switch (action.type) {
            case actionTypes.Login: {
                //console.log("action.payload: ", action.payload)
                const { authToken } = action.payload;
                const { user } = action.payload;

                return { authToken, user };
            }

            case actionTypes.Register: {
                const { authToken } = action.payload;

                return { authToken, user: undefined };
            }

            case actionTypes.Logout: {
                return initialAuthState;
            }

            case actionTypes.UserLoaded: {
                const { user } = action.payload;
                return { ...state, user };
            }

            case actionTypes.SetUser: {
                const { user } = action.payload;
                return { ...state, user };
            }

            default:
                return state;
        }
    }
);

export const actions = {
    login: (authToken, user) => {
        return (dispatch) => {
            localStorage.setItem("sid", authToken);
            dispatch({ type: actionTypes.Login, payload: { authToken, user } });
        };
    },
    register: (authToken) => ({
        type: actionTypes.Register,
        payload: { authToken },
    }),
    logout: () => {
        return (dispatch) => {
            dispatch({ type: actionTypes.Logout });
        };
    },
    requestUser: (user) => ({
        type: actionTypes.UserRequested,
        payload: { user },
    }),
    fulfillUser: (user) => ({ type: actionTypes.UserLoaded, payload: { user } }),
    setUser: (user) => ({ type: actionTypes.SetUser, payload: { user } }),
};

export function* saga() {
    yield takeLatest(actionTypes.Register, function* registerSaga() {
        //console.log("saga2")
        yield put(actions.requestUser());
    });

    yield takeLatest(actionTypes.UserRequested, function* userRequested() {
        //console.log("saga3")
        const { data: user } = yield get("getLoggedinUser");
        //console.log("user: ", user)
        yield put(actions.fulfillUser(user));
    });
}
